import { useBuild } from "../../lib/BuildContext";
import { TriggerJob } from "../../lib/types";
import TriggerJobSummary from "../TriggerJobSummary";
import Button from "app/components/shared/Button";

interface Props {
  job: TriggerJob;
}

export const TriggerJobDetails = ({ job }: Props) => {
  const { build, store } = useBuild();

  const jobs = (store.stepJobs.get(job.stepUuid) as TriggerJob[]) || [];
  // eslint-disable-next-line id-length
  const isRetry = Boolean(jobs.find((j) => j.retriedInJobUuid === job.id));

  return (
    <div className="job-list-pipeline">
      <TriggerJobSummary job={job} isRetry={isRetry} build={build} />

      {job.triggeredBuild && job.triggeredBuild.streamName && !job.triggeredBuild.destroyedAt && (
        <>
          <div className="-my-[10px] rounded-b border-gray bg-slate-100/70 p-3 shadow-inner">
            <turbo-cable-stream-source
              signed-stream-name={job.triggeredBuild.streamName}
              channel="Turbo::StreamsChannel"
            />
            <div id={job.triggeredBuild.streamTargetDomId}>
              <turbo-frame
                id={job.triggeredBuild.stepsStreamDomId}
                src={job.triggeredBuild.stepsUrl}
              >
                <div>Loading steps...</div>
              </turbo-frame>
            </div>
          </div>

          <Button href={job.triggeredBuild.url} theme="small" target="_blank" className="mt-5">
            <span className="after:ml-1 after:content-['→']">Go to build</span>
          </Button>
        </>
      )}
    </div>
  );
};
